export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || 'support@promptcrew.io';

export const GENERIC_SERVER_ERROR_MESSAGE =
  'An internal error occurred. Please contact your system administrator.';

export const getSupportInstructionMessage = (isAuthenticated) => {
  if (isAuthenticated) {
    return 'Something went wrong. Please use "Submit Feedback" in the bottom left and choose "Request Support" so we can investigate.';
  }

  return `Something went wrong. Please email support at ${SUPPORT_EMAIL}.`;
};
